import { useFlag, useVariant } from '@calendly/feature-check-react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import {
  isCurrentSubscriptionInitializedSelector,
  isOnFreeStageSelector
} from 'features/billing'
import { useTrack, TRACKING_EVENT_NAMES } from 'hooks/analytics_events'
import { useNotetakerMarketEligibility } from 'hooks/notetaker_visibility/useNotetakerMarketEligibility'

export const useNotetakerFiveFreeRecapsExperiment = (shouldCheck = true) => {
  const isCurrentSubscriptionInitialized = useSelector(isCurrentSubscriptionInitializedSelector)
  const isOnFreeStage = useSelector(isOnFreeStageSelector)
  const hasMeetingIntelligenceFlag = useFlag('meeting_intelligence')
  const { isEligible: isMarketEligible, isLoading: isMarketEligibilityLoading } = useNotetakerMarketEligibility()
  const isLoading = shouldCheck && hasMeetingIntelligenceFlag && (
    isMarketEligibilityLoading || (isMarketEligible && !isCurrentSubscriptionInitialized)
  )
  const shouldTrackExperiment = shouldCheck && !isLoading && isOnFreeStage
    && hasMeetingIntelligenceFlag && isMarketEligible
  const variant = useVariant('growth_notetaker_five_free_recaps', shouldTrackExperiment)
  const isInExperiment = variant === 'variant'
  const isExperimentAssignmentLoading = shouldTrackExperiment && variant === undefined
  const track = useTrack()

  useEffect(() => {
    if (shouldTrackExperiment && variant) {
      track({
        name: TRACKING_EVENT_NAMES.FEATURE_FLAG_ENCOUNTERED,
        properties: {
          flag_key: 'growth_notetaker_five_free_recaps',
          variation_key: variant,
          rule: 'ab_test',
          source: 'frontend'
        }
      })
    }
  }, [shouldTrackExperiment, variant, track])

  if (!shouldTrackExperiment) {
    return { isInExperiment: false, isLoading }
  }

  return { isInExperiment, isLoading: isExperimentAssignmentLoading }
}
